import { sanitise } from '@/domain/utils/DataSanitiser';

const stripTags = (string, stripAll = false, allowEditInterfaceText = true) => {
	const baseTags = ['b', 'strong', 'i', 'em'];
	const allowedTags = stripAll ? [] : allowEditInterfaceText ? [...baseTags, 'edit-interface-text'] : baseTags;
	const allowedAttributes = stripAll ? [] : ['class', 'id', 'payload'];

	return sanitise(string, {
		ALLOWED_TAGS: allowedTags,
		ALLOWED_ATTR: allowedAttributes,
	});
};

const toCamelCase = (sentence) =>
	sentence.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (camelCaseMatch, i) {
		if (+camelCaseMatch === 0) {
			return '';
		}

		return i === 0 ? camelCaseMatch.toLowerCase() : camelCaseMatch.toUpperCase();
	});

function toSnakeCase(sentence) {
	return sentence
		.replace(/([A-Z])/g, (match, uppercaseLetter, index) => (index > 0 ? '_' : '') + uppercaseLetter)
		.toLowerCase();
}

const stripQuery = (url) => (typeof url === 'string' ? url.split('?')[0] : null);

export { stripTags, toCamelCase, toSnakeCase, stripQuery };
